import React, {FC} from "react";
import {TurnoRecord} from "@commons/mapping/TurnoRecord";
import {ItemTypes, Tool} from "../../../../core/DnDItemTypes";
import {GiustificativoRecord} from "@commons/mapping/GiustificativoRecord";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import {DropTargetMonitor, useDrop} from "react-dnd";
import classNames from "classnames";
import styles from "../pianificazione.module.css";
import TooltipEx from "@components/Tooltip";

interface TargetBoxProps {
    onClick?: React.MouseEventHandler<HTMLDivElement>,
    onDropTurno: (item: TurnoRecord) => void,
    onDropTurnoTool: (item: Tool) => void,
    onDropGiustificativo: (item: GiustificativoRecord) => void,
    onDropFiliale: (item: AziendaRecord) => void,
    children: React.ReactNode,
    className?: string,
    tooltip?: string,
    isWeek?: boolean,
    enabled?: boolean,
}

export const TargetBox: FC<TargetBoxProps> = (props) => {
    const {onClick, onDropFiliale, onDropTurno, onDropTurnoTool, onDropGiustificativo, children, className, isWeek, tooltip, enabled = true,} = props
    const [{canDrop, isOver}, drop] = useDrop(
        () => ({
            accept: [ItemTypes.AZIENDA, ItemTypes.TURNO, ItemTypes.TURNO_PENCIL, ItemTypes.TURNO_ERASER, ItemTypes.GIUSTIFICATIVO],
            drop(item: AziendaRecord | TurnoRecord | GiustificativoRecord | Tool, monitor) {
                console.log(monitor.getItemType())
                switch (monitor.getItemType()) {
                    case ItemTypes.AZIENDA:
                        onDropFiliale(item as AziendaRecord);
                        break;
                    case ItemTypes.TURNO:
                        onDropTurno(item as TurnoRecord);
                        break;
                    case ItemTypes.TURNO_PENCIL:
                    case ItemTypes.TURNO_ERASER:
                        onDropTurnoTool(item as Tool);
                        break;
                    case ItemTypes.GIUSTIFICATIVO:
                        onDropGiustificativo(item as GiustificativoRecord);
                        break;
                }
            },
            canDrop(item: AziendaRecord | TurnoRecord | GiustificativoRecord | Tool, monitor) {
                if (enabled) {
                    // Il drop del turno e della filiale è sempre possibile, il drop dei giustificativi è vincolato dalla destinazione...
                    if (monitor.getItemType() === ItemTypes.GIUSTIFICATIVO) { // Se il target è la settimana, permetto drop solo per giustificativi orari su mancante
                        return !isWeek || ((item as GiustificativoRecord).tipoGiu === 'O' && (item as GiustificativoRecord).tipoOreGiu === 'M');
                    } else if (monitor.getItemType() === ItemTypes.AZIENDA
                        || monitor.getItemType() === ItemTypes.TURNO_PENCIL
                    ) { // Se il target è la settimana, NON permetto drop
                        return !isWeek;
                    } else return true;
                } else return false;
            },
            hover(item: AziendaRecord | TurnoRecord | GiustificativoRecord | Tool) {
                //console.log('hover', item.files, item.items)
            },
            collect: (monitor: DropTargetMonitor) => {
                const item = monitor.getItem() as any
                if (item) {
                    //console.log('collect', item.files, item.items)
                }

                return {
                    isOver: monitor.isOver(),
                    canDrop: monitor.canDrop(),
                }
            },
        }),
        [props],
    )

    const isActive = canDrop && isOver;
    const content = <div ref={drop} className={classNames(className, (isActive ? styles.onDrop : ''))} onClick={onClick}>
        {/*{isActive && '['}*/}
        {children}
        {/*{isActive && ']'}*/}
    </div>;

    return <>
        {tooltip && <TooltipEx tooltip={tooltip}>{content}</TooltipEx>}
        {!tooltip && <>{content}</>}
    </>
}
